import { AppButton, AppImages } from 'components';
import { useState, Fragment } from 'react';
import * as AppPics from 'assets/images';
import Joi from 'joi';
import useForgotPassword from 'hooks/API/useForgotPassword';
import { notifier } from 'components/Toaster';

function ForgotPassword() {
  const { mutate, isLoading } = useForgotPassword();

  const [email, setEmail] = useState('');
  const [successScreen, setScreen] = useState(false);

  const [formErrors, setFormErrors] = useState([]);

  function handleForgotPassword() {
    if (isLoading) return;
    setFormErrors([]);

    const data = { email };

    const validator = forgotPasswordSchema.validate(data, {
      abortEarly: false,
      allowUnknown: true,
    });

    if (validator?.error) {
      setFormErrors(validator.error?.details ?? []);
      return;
    }
    mutate(data, {
      onSuccess(successData) {
        notifier.success(successData.data.status);
        setScreen(true);
      },
      onError(failData) {
        notifier.error(failData?.response.data.message);
        setEmail('');
      },
    });
  }
  return (
    <div className="container-fluid login_wrap">
      <div className="row login">
        <div className="col-md-6 login__imgSection">
          <AppImages
            className="login__imgSection-logo"
            alt="Login Logo"
            src={AppPics.LoginLogoSvg}
          />
        </div>
        {!successScreen && (
          <Fragment>
            <div className="col-md-6 login__contentSection">
              <div className="login__contentSection-head">
                <h1>Welcome to edpodia backdoor!</h1>
                <h2>The super study lab we built together!</h2>
                <h3>Forgot Password?</h3>
                <span>Enter your email address to receive a new password...</span>
              </div>
              <div className="login__contentSection-wrap">
                <form className="login__contentSection-wrapForm">
                  <input
                    type="text"
                    name="username"
                    placeholder="Email"
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                  />
                  <AppButton
                    variantClass="btn-primary"
                    onClick={handleForgotPassword}
                    disabled={isLoading}
                  >
                    Submit
                  </AppButton>
                </form>
              </div>
            </div>
          </Fragment>
        )}
        {successScreen && (
          <Fragment>
            <div className="col-md-6 login__contentSection">
              <div className="login__contentSection-head">
                <h3>Your new password has been sent to your registered email</h3>
              </div>
              <div className="login__contentSection-wrap">
                <form className="login__contentSection-wrapForm">
                  <a className="login__contentSection-wrapFormKey" href="/login">
                    Login here
                  </a>
                </form>
              </div>
            </div>
          </Fragment>
        )}
      </div>
    </div>
  );
}

const forgotPasswordSchema = Joi.object({
  email: Joi.string().email({ tlds: false }).trim(),
});

export default ForgotPassword;
